import React, { useState, useEffect, useRef } from 'react';
import { Typography, Box } from '@mui/material';
import { useMsal } from "@azure/msal-react";
import { InteractionRequiredAuthError } from "@azure/msal-browser";
import powerBISettings from '../../configs/powerBISettings';
import { protectedResources } from '../../msalConfig';

function QueryBuilder(props) {
  const { isAuthenticated, userType, selectedTenant, userId } = props;
  const [customQueryAppURL, setCustomQueryAppURL] = useState("");
  const [accessToken, setAccessToken] = useState("");
  const activeBuilderRef = useRef(null);
  const { instance, accounts } = useMsal();

  // Get access token using MSAL acquireTokenSilent
  useEffect(() => {
    const fetchAccessToken = async () => {
      if (accounts && accounts.length > 0) {
        try {
          const response = await instance.acquireTokenSilent({
            account: accounts[0],
            scopes: protectedResources.tenantAdmin.scopes
          });
          setAccessToken(response.accessToken);
        } catch (error) {
          if (error instanceof InteractionRequiredAuthError) {
            // Fallback to interactive method if silent fails
            try {
              const response = await instance.acquireTokenPopup({
                account: accounts[0],
                scopes: protectedResources.tenantAdmin.scopes
              });
              setAccessToken(response.accessToken);
            } catch (popupError) {
              setAccessToken("");
            }
          } else {
            setAccessToken("");
          }
        }
      }
    };
    fetchAccessToken();
  }, [instance, accounts]);

  useEffect(() => {
    if (
      isAuthenticated &&
      userId &&
      userType?.tenantId &&
      selectedTenant &&
      selectedTenant !== "Select Tenant" &&
      accessToken
    ) {
      const customQueryExecutorUrl = powerBISettings.customQueryExecutorUrl;
      const idpToken = localStorage.getItem('customidp');
       const jwtToken = localStorage.getItem('jwttoken');  
      let url = `${customQueryExecutorUrl}${selectedTenant}/${parseInt(userId)}`;
      if (idpToken) {
         url += `?customidp=${encodeURIComponent(idpToken)}&token=${encodeURIComponent(jwtToken)}`;  
      } else if (accessToken) {
        url += `?token=${accessToken}`;
      }
      setCustomQueryAppURL(url);
      if (activeBuilderRef.current) {
        activeBuilderRef.current.style.height = getQueryBuilderHeight() + 'px';
      }
    } else {
      setCustomQueryAppURL("");
    }
  }, [isAuthenticated, selectedTenant, userId, userType, accessToken]);

  useEffect(() => {
    if (userType && !props.isServiceAdmin && !props.isSupportImplUser) {
      
      const customQueryExecutorUrl = powerBISettings.customQueryExecutorUrl;
      const idpToken = localStorage.getItem('customidp');
       const jwtToken = localStorage.getItem('jwttoken');  
      let tenantId = selectedTenant && selectedTenant !== "Select Tenant" ? selectedTenant : props.userTenantId;
      if(userType.type === 'serviceadmin' && selectedTenant === "Select Tenant"){
        setCustomQueryAppURL("");
        return;
      }
      let url = `${customQueryExecutorUrl}${tenantId}/${parseInt(userId)}`;
      if (idpToken) {
        // url += `?customidp=${idpToken}`;
         url += `?customidp=${encodeURIComponent(idpToken)}&token=${encodeURIComponent(jwtToken)}`; 
      } else if (accessToken) {
        url += `?token=${accessToken}`;
      }
      setCustomQueryAppURL(url);
      if (activeBuilderRef.current) {
        activeBuilderRef.current.style.height = getQueryBuilderHeight() + 'px';
      }
    } else {
      setCustomQueryAppURL("");
    }
  }, [userType, props.isServiceAdmin, props.isSupportImplUser, userId, accessToken]);

  const getQueryBuilderHeight = () => {
    var height = window.innerHeight - 196;
    var calculatedHeight = Math.ceil(height);
    return calculatedHeight;
  };

  return (
    <div ref={activeBuilderRef} id="divActiveBuilder" >
        <Box sx={{ p: 1, border: '1px solid #eee', borderRadius: 2, minHeight: 300 }}>
            {/* <Typography variant="h6" sx={{ mb: 0.5 }}>Custom Query Builder</Typography> */}
            {customQueryAppURL && (
        <iframe
          src={customQueryAppURL}
          title="Custom Query Executor"
            style={{ width: '100%', minHeight: 'calc(95vh - 100px)' , border: 'none' }}
        />
      )}
          </Box>
      
      {/* Add your custom query builder UI and logic here */}
    </div>
  );
}

export default QueryBuilder;